import EmailLink from "./EmailLink";
import style from "./Footer.module.css";
export default function Footer() {
  return (
    <>
      {/* BUNTER FOOTER */}
      <footer className={style.footer}>
        <div className={style.footer__container}>
          
          {/* LINKS */}
          <div className={style.footer__left}>
            <img
              src="../Signet_DuoDay_negativ_Print.png"
              alt="DUOday Hannover Logo"
              className={style.footer__logo}
            />
            <p className={style.footer__description}>
              Förderung der Inklusion von Menschen mit Behinderung in den Arbeitsmarkt
            </p>
          </div>

          {/* RECHTS */}
          <div className={style.footer__right}>
            <h4 className={style.footer__subtitle}>Kontakt</h4>

            <p>
              <strong>Email:</strong>{" "}
              <EmailLink
                user="duoday-hannover"
                domain="enercity.de"
                className={style.footer__link}
              />
            </p>

            <p>
              <strong>Telefon:</strong>{" "}
              <a href="tel:+495114303016" className={style.footer__link}>
                +49 511 430 3016
              </a>
            </p>

            <p>
              <strong>Handy:</strong>{" "}
              <a href="tel:+491622595194" className={style.footer__link}>
                +49 162 2595194
              </a>
            </p>

            <p>
              <strong>Adresse:</strong> Glockseeplatz 1, 30169 Hannover
            </p>
          </div>
        </div>
      </footer>

      {/* ✅ UNTERER BEREICH – OHNE HINTERGRUND */}
      <div className={style.footer__meta}>
        <span>© 2026 DUOday</span>

        <div className={style.footer__metaLinks}>
          <a href="/barrierefreiheit">Barrierefreiheit</a>
          <a href="/datenschutz">Datenschutz</a>
          <a href="/impressum">Impressum</a>
        </div>
      </div>
    </>
  );
}